import { Container } from "@fideus-ui/core";
import { createFileRoute, getRouteApi, Navigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../../../_app/featureFlags";
import { JournalEntriesTab } from "../../../companies/journalEntries/JournalEntriesTab";

const companyRoute = getRouteApi("/firmen/$companyId");

export const Route = createFileRoute("/firmen/$companyId/buchungen")({
  loader: ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.generalLedger.listAccounts.queryOptions({ companyId })
    );
  },
  component: BuchungenRoute,
});

function BuchungenRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();
  const showJournalEntries = useIsFeatureEnabled("showJournalEntries");

  if (!showJournalEntries) {
    return (
      <Navigate
        to="/firmen/$companyId/aufgaben"
        params={{ companyId }}
        search={jahr !== undefined ? { jahr } : {}}
      />
    );
  }

  return (
    <Container>
      <JournalEntriesTab companyId={companyId} selectedYear={jahr} />
    </Container>
  );
}
